import React from "react";
import "./AllDepartment.css";

const AllDepartment= () => {
  return (
    <div className="main-content">
      <div className="breadcrumb">
        Home / <span>View All</span>
      </div>
      <h2>Departments List</h2>

      <div className="page-header">
        <div> 
          <h2>View all departments

          </h2>
          
        </div>
        <div className="header-buttons">
        
          <button className="btn blue">+ Create New</button>
        </div>
      </div>

      <div className="card">
        <div className="top-controls">
          {/* <div>
            Show{" "}
            <select>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
            </select>{" "}
            entries
          </div> */}
          <div className="search-box">
            Search: <input type="text" />
          </div>
        </div>

        <div className="buttons">
          <button>Copy</button>
          <button>CSV</button>
          <button>Excel</button>
          <button>PDF</button>
          <button>Print</button>
          <button className="dropdown">Column visibility ▾</button>
        </div>

        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Previlage</th>
              <th>Enable/Disable</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="11" className="empty">
                No data available in table
              </td>
            </tr>
          </tbody>
        </table>

        <div className="table-footer">
          <p>Showing 0 to 0 of 0 entries</p>
          <div>
            <button disabled>Previous</button>
            <button disabled>Next</button>
          </div>
        </div>
      </div>

      <footer>
        <p>
          Copyright © 2025 <span className="brand">Ample Markets</span>. All
          rights reserved. <span className="version">Version 2.0</span>
        </p>
      </footer>
    </div>
  );
};

export default AllDepartment;
